import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import Badge from 'components/v2/Badge';
import Container from 'components/v2/container';
import MarketsAPIUtils from 'utils/MarketsAPIUtils';
import SessionStore from 'stores/SessionStore';
import CustomerSearch from 'components/site/customer-search';
import Multiselect from 'components/v2/multi-select';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import AccessorialRatesTable from './AccessorialRatesTable';
import EditButton from '../../v2/buttons/EditButton';
import StandardRatesModal from './modals/StandardRatesModal';
import { Button, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger, } from '@cargomatic/ui';
import ChevronDownIcon from 'components/v2/icons/ChevronDownIcon';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { sluggify } from 'utils/localization/utils';
const STATUS = [
    { name: 'Confirmed', slug: 'confirmed', localizationSlug: 'CONFIRMED' },
    { name: 'Awaiting', slug: 'awaiting', localizationSlug: 'AWAITING' },
    { name: 'Expired', slug: 'expired', localizationSlug: 'EXPIRED' },
    { name: 'Declined', slug: 'declined', localizationSlug: 'DECLINED' },
];
const USER_TYPES = [
    {
        name: 'Carrier',
        slug: 'carrier',
        localizationSlug: 'CARRIER',
        titleize: true,
    },
    {
        name: 'Shipper',
        slug: 'shipper',
        localizationSlug: 'SHIPPER',
        titleize: true,
    },
];
export default function AccessorialRates() {
    const pathIncludesModalVal = qs.parse(window.location.search, {
        ignoreQueryPrefix: true,
    });
    const queryCustomer = pathIncludesModalVal && pathIncludesModalVal.customer;
    const queryCustomerName = pathIncludesModalVal && pathIncludesModalVal.customerName;
    const [customerType, setUserTypeMulti] = useState([]);
    const [customers, setCustomers] = useState(queryCustomer ? [{ _id: queryCustomer, name: queryCustomerName }] : []);
    const [status, setStatusMulti] = useState([]);
    const [market, setMarketMulti] = useState([]);
    const [marketsList, setMarketsList] = useState([]);
    const [selectedCarrierMarket, setSelectedCarrierMarket] = useState([]);
    const [selectedShipperMarket, setSelectedShipperMarket] = useState([]);
    const [standardRateType, setStandardRateType] = useState('');
    const [showStandardRatesModal, setShowStandardRatesModal] = useState(false);
    const [canUpdate, setCanUpdate] = useState(SessionStore.isAbleToEditAccessorialLaneRate());
    const [autoApply, setAutoApply] = useState(null);
    const [selectedAutoApplyOption, setSelectedAutoApplyOption] = useState(null);
    const { t } = useTranslation();
    useEffect(() => {
        const getMarketsList = async () => {
            try {
                const marketsList = await MarketsAPIUtils.getMarkets();
                if (marketsList.entity.markets) {
                    const marketNames = _.map(marketsList.entity.markets, (market) => {
                        return {
                            _id: market.id,
                            name: market.name,
                            slug: market.name,
                        };
                    });
                    setMarketsList(marketNames);
                }
            }
            catch (e) {
                console.error('failed to fetch market values: ', e);
            }
        };
        getMarketsList();
    }, []);
    const renderCustomerFilter = () => {
        return (React.createElement(CustomerSearch, { clearOnSelect: true, type: "customer", onSelect: (_item, value) => {
                filterByCustomer(value);
            }, placeholder: t('SEARCH_FOR_CUSTOMER') }));
    };
    const filterByCustomer = (value) => {
        setCustomers((currentCustomers) => {
            return _.uniq(currentCustomers.concat(value));
        });
    };
    const handleRemoveCustomer = (id) => {
        setCustomers((currentCustomers) => {
            return _.uniq(currentCustomers.filter((customer) => customer.value !== id));
        });
    };
    const handleStandardRateEditClick = (type) => {
        setStandardRateType(type);
        setShowStandardRatesModal(true);
    };
    const renderUserTypesMulti = () => {
        return (React.createElement("div", { "data-testid": "div-7166eaac", className: "mb-4" },
            React.createElement(Multiselect, { dataTestId: "Multiselect-0ead3562", label: t('USER_TYPE'), items: USER_TYPES, onSelect: handleSelectUserTypeMulti })));
    };
    const handleSelectUserTypeMulti = (value) => {
        let selectedValue = value.map((val) => {
            return val.name;
        });
        setUserTypeMulti(selectedValue);
    };
    const handleAutoApplyFilter = (checked, value, localizedLabel) => {
        setAutoApply(checked ? value === 'enabled' : null);
        setSelectedAutoApplyOption(checked ? localizedLabel : null);
    };
    const renderFilterbyStatusMulti = () => {
        return (React.createElement("div", { "data-testid": "div-d20cd1da", className: "mb-4" },
            React.createElement(Multiselect, { dataTestId: "Multiselect-e594f3e3", label: titleize(t('STATUS')), items: STATUS, onSelect: handleSelectStatusMulti })));
    };
    const renderAutoApplyFilter = () => {
        const options = [
            {
                label: 'Enabled',
                value: 'enabled',
                localizationSlug: 'ENABLED',
                localizedLabel: t('ENABLED'),
            },
            {
                label: 'Disabled',
                value: 'disabled',
                localizationSlug: 'DISABLED',
                localizedLabel: t('DISABLED'),
            },
        ];
        return (React.createElement("div", { "data-testid": "div-c21cd2ea", className: "" },
            React.createElement(DropdownMenu, { key: "DropdownMenu-d594de3", className: "mb-4" },
                React.createElement(DropdownMenuTrigger, { asChild: true },
                    React.createElement(Button, { variant: "outline", size: "sm", className: "h-10 gap-1 text-grey-darker" },
                        React.createElement("span", { className: "sr-only sm:not-sr-only sm:whitespace-nowrap" }, selectedAutoApplyOption
                            ? t('AUTO_APPLY_FILTER', { value: selectedAutoApplyOption })
                            : t('FILTER_FOR_AUTO_APPLY')),
                        React.createElement(ChevronDownIcon, { className: "ml-2 w-4 h-5" }))),
                React.createElement(DropdownMenuContent, { align: "end" }, options.map(({ value, localizationSlug, localizedLabel }) => (React.createElement(DropdownMenuCheckboxItem, { onCheckedChange: (checked) => handleAutoApplyFilter(checked, value, localizedLabel), checked: selectedAutoApplyOption === localizedLabel }, t(localizationSlug))))))));
    };
    const handleSelectStatusMulti = (value) => {
        let selectedValue = value.map((val) => {
            return val.name;
        });
        setStatusMulti(selectedValue);
    };
    const renderFilterbyMarketMulti = () => {
        return (React.createElement("div", { "data-testid": "div-58434cd1", className: "mb-4" },
            React.createElement(Multiselect, { dataTestId: "Multiselect-c3c39ab2", label: titleize(t('MARKET', { count: 1 })), items: marketsList, onSelect: handleSelectMarketMulti, dropdownClassName: "max-w-xs" })));
    };
    const renderActiveFilters = () => {
        return (React.createElement("div", { "data-testid": "div-ab433f1f", className: "flex mb-4" },
            customers.length ||
                status.length ||
                market.length ||
                customerType.length
                ? `Active Filters:  `
                : `Active Filters: None`,
            status.map((status, i) => (React.createElement(Badge, { dataTestId: `Badge-9a680f9a-${i}`, color: "blue", className: "mr-1", withRemove: true, key: status },
                "Status: ",
                status))),
            market.map((m, i) => (React.createElement(Badge, { dataTestId: `Badge-2e03d27e-${i}`, color: "blue", className: "mr-1", withRemove: true, key: m },
                "Market: ",
                m))),
            customerType.map((type, i) => (React.createElement(Badge, { dataTestId: `Badge-3be3ab82-${i}`, color: "blue", className: "mr-1", withRemove: true, key: type },
                "Customer Type: ",
                type))),
            customers.map((customer, i) => (React.createElement(Badge, { dataTestId: `Badge-04eb0baa-${i}`, color: "blue", className: "mr-1", withRemove: true, onRemove: () => setCustomers(customers.filter((c, ci) => ci !== i)), key: customer.name }, t('CUSTOMER_NAME_DATA', { name: customer.name })))),
            selectedAutoApplyOption && (React.createElement(Badge, { dataTestId: `Badge-04eb0b1c`, color: "blue", className: "mr-1", withRemove: true, key: `auto-apply-${selectedAutoApplyOption}` }, t('AUTO_APPLY_STATUS', {
                status: t(sluggify(selectedAutoApplyOption)),
            })))));
    };
    const renderStandardCards = () => {
        return (React.createElement("div", { "data-testid": "div-d5168f6a", className: "flex" },
            React.createElement("h3", { "data-testid": "h3-504aa841", className: "my-0 mb-4 w-full" }, t('ACCESSORIAL_RATES')),
            React.createElement("div", { "data-testid": "div-668652dd" },
                React.createElement("div", { "data-testid": "div-9aa3bf98", className: "flex mb-2" },
                    React.createElement(Badge, { dataTestId: "Badge-3435d210", color: "blue", className: "mr-1 mt-2", withRemove: false, onClick: () => { } }, t('CARRIER_STANDARD_CARD')),
                    renderCarrierMarketList(),
                    React.createElement(EditButton, { dataTestId: "EditButton-c9735c50", size: "small", onClick: () => handleStandardRateEditClick('carrier'), disabled: !selectedCarrierMarket || !selectedCarrierMarket.length })),
                React.createElement("div", { "data-testid": "div-9fcfc16d", className: "flex" },
                    React.createElement(Badge, { dataTestId: "Badge-d77daa81", color: "green", className: "mt-2", withRemove: false, onClick: renderShipperMarketList }, t('SHIPPER_STANDARD_CARD')),
                    renderShipperMarketList(),
                    React.createElement(EditButton, { dataTestId: "EditButton-7ec110b6", size: "small", onClick: () => handleStandardRateEditClick('shipper'), disabled: !selectedShipperMarket || !selectedShipperMarket.length })))));
    };
    const renderCarrierMarketList = () => {
        return (React.createElement("div", { "data-testid": "div-44d7fdb5", className: "ml-4 mr-2" },
            React.createElement(Multiselect, { dataTestId: "Multiselect-70032690", label: titleize(t('MARKET', { count: 1 })), items: marketsList, onSelect: handleCarrierMarketSelection, dropdownClassName: "max-w-xs" })));
    };
    const renderShipperMarketList = () => {
        return (React.createElement("div", { "data-testid": "div-dddd5dcc", className: "ml-4 mr-2" },
            React.createElement(Multiselect, { dataTestId: "Multiselect-22fa706d", label: titleize(t('MARKET', { count: 1 })), items: marketsList, onSelect: handleShipperMarketSelection, dropdownClassName: "max-w-xs" })));
    };
    const handleCarrierMarketSelection = (value) => {
        let selectedMarket = value.map((val) => {
            return val.name;
        });
        setSelectedCarrierMarket(selectedMarket);
    };
    const handleShipperMarketSelection = (value) => {
        let selectedMarket = value.map((val) => {
            return val.name;
        });
        setSelectedShipperMarket(selectedMarket);
    };
    const handleSelectMarketMulti = (value) => {
        let selectedValue = value.map((val) => {
            return val.name;
        });
        setMarketMulti(selectedValue);
    };
    return (React.createElement(Container, { dataTestId: "Container-ced1eb72", className: "py-10" },
        React.createElement("div", { "data-testid": "div-327f34c2", className: "right-16" }, renderStandardCards()),
        React.createElement("hr", { "data-testid": "hr-918b5c68" }),
        React.createElement("div", { "data-testid": "div-ddf99bf1" }, renderActiveFilters()),
        React.createElement("div", { "data-testid": "div-8765265e", className: "flex" },
            React.createElement("div", { "data-testid": "div-d29a0313", className: "w-full md:w-1/6 mr-3" }, renderUserTypesMulti()),
            React.createElement("div", { "data-testid": "div-1ae29c81", className: "w-full md:w-1/6 px-3" }, renderCustomerFilter()),
            React.createElement("div", { "data-testid": "div-aa03ba4a", className: "w-full md:w-1/6 px-3" }, renderFilterbyMarketMulti()),
            React.createElement("div", { "data-testid": "div-9b569dba", className: "w-full md:w-1/6 px-3" }, renderFilterbyStatusMulti()),
            featureEnabled(CONFIGURED_FEATURES === null || CONFIGURED_FEATURES === void 0 ? void 0 : CONFIGURED_FEATURES.AUTO_APPLY_ACCESSORIAL) && (React.createElement("div", null, renderAutoApplyFilter()))),
        React.createElement(AccessorialRatesTable, { autoApply: autoApply, customer: (customers === null || customers === void 0 ? void 0 : customers.length) ? _.map(customers, '_id') : null, customerType: (customerType === null || customerType === void 0 ? void 0 : customerType.length)
                ? _.map(customerType, (type) => type.toLowerCase())
                : null, canUpdate: canUpdate, status: (status === null || status === void 0 ? void 0 : status.length)
                ? _.map(status, (status) => status.toLowerCase())
                : null, market: (market === null || market === void 0 ? void 0 : market.length)
                ? _.map(market, (market) => market.toLowerCase())
                : null }),
        React.createElement(StandardRatesModal, { show: showStandardRatesModal, onHide: () => setShowStandardRatesModal(false), canUpdate: canUpdate, market: standardRateType === 'carrier'
                ? selectedCarrierMarket
                : selectedShipperMarket, type: standardRateType })));
}
